import { VFC } from 'react'
import { Routes, Route } from 'react-router-dom'

import { PrivateRoutes } from 'infrastructure/shared/components'

import TaskListContainer from './List/Container'

const TaskRoutes: VFC = () => {
  return (
    <Routes>
      <Route element={<PrivateRoutes />}>
        <Route path='list' element={<TaskListContainer />} />
      </Route>
    </Routes>
  )
}

export default TaskRoutes
